import { useMemo } from 'react';
import styled from 'styled-components';
import { Typography, Stack } from '@mui/material';
import { Chip } from '../../../components';
import { capitalize, formatDuration } from '../../../utils/common';
import { localizeDate } from '../../../utils/datetime';

const TooltipWrapper = styled(Stack)`
  background: ${({ theme }) => theme.palette.common.white};
  border: 1px solid ${({ theme }) => theme.palette.common.gray};
  border-radius: 4px;
  padding: 20px 22px;
  gap: 8px;
`;

const chipColorMap = {
  error: 'error',
  success: 'success',
} as any;

const chipLabelMap = {
  error: 'Failure',
  success: 'Success',
} as any;

const Tooltip = ({ payload }: any) => {
  const data = useMemo(() => payload?.[0]?.payload, [payload]);

  const execTimeStr = useMemo(() => {
    if (data.status === 'error') return '0 Secs';
    return formatDuration(data.execution_time);
  }, [data]);

  return (
    <TooltipWrapper>
      <Chip
        sx={{ width: 'fit-content', mb: 1 }}
        label={chipLabelMap[data.status]}
        color={chipColorMap[data.status]}
      />
      <Stack direction="row" sx={{ gap: 2 }}>
        <Typography sx={{ color: 'common.gray2', width: '110px' }}>
          Execution Time:
        </Typography>
        <Typography>{execTimeStr}</Typography>
      </Stack>
      <Stack direction="row" sx={{ gap: 2 }}>
        <Typography sx={{ color: 'common.gray2', width: '110px' }}>
          Materialization:
        </Typography>
        <Typography>{capitalize(data.materialization)}</Typography>
      </Stack>
      <Stack direction="row" sx={{ gap: 2 }}>
        <Typography sx={{ color: 'common.gray2', width: '110px' }}>
          Time:
        </Typography>
        <Typography>
          {localizeDate(data.time_utc).format('MMM D LT')}
        </Typography>
      </Stack>
      {data.materialization === 'incremental' && (
        <Stack direction="row" sx={{ gap: 2 }}>
          <Typography sx={{ color: 'common.gray2', width: '110px' }}>
            Full Refresh:
          </Typography>
          <Typography>{data.full_refresh ? 'True' : 'False'}</Typography>
        </Stack>
      )}
    </TooltipWrapper>
  );
};

const RunsChartTooltip = ({ active, payload }: any) => {
  if (!(active && payload?.[0]?.payload)) {
    return null;
  }

  return <Tooltip payload={payload} />;
};

export default RunsChartTooltip;
